import _en from './en.json';
import _es from './es.json';
import _ja from './ja.json';
import _fr from './fr.json';
import _de from './de.json';
import _pt from './pt.json';
import _it from './it.json';
import _zt from './zt.json';
import _ko from './ko.json';
import _zh from './zh.json';
import _ru from './ru.json';
import _pl from './pl.json';
import _tr from './tr.json';
import _vi from './vi.json';

export const en = { ..._en } as const;
export type MessageBundle = typeof en;
export type MessageId = keyof MessageBundle;

export const es: MessageBundle = _es as MessageBundle;
export const ja: MessageBundle = _ja as MessageBundle;
export const fr: MessageBundle = _fr as MessageBundle;
export const de: MessageBundle = _de as MessageBundle;
export const pt: MessageBundle = _pt as MessageBundle;
export const it: MessageBundle = _it as MessageBundle;
export const zt: MessageBundle = _zt as MessageBundle;
export const ko: MessageBundle = _ko as MessageBundle;
export const zh: MessageBundle = _zh as MessageBundle;
export const ru: MessageBundle = _ru as MessageBundle;
export const pl: MessageBundle = _pl as MessageBundle;
export const tr: MessageBundle = _tr as MessageBundle;
export const vi: MessageBundle = _vi as MessageBundle;
